const API_URL = "https://server.womi.ma";
const API_IMAGES =  "https://server.womi.ma";

// http://localhost:3100

// const API_URL = "http://localhost:3100";
// const API_IMAGES =  "http://localhost:3100";

export default{ API_URL , API_IMAGES };
